// Typed client for the promoted `engine_settings` entity (Stage 2). On the
// `http` backend it uses the dedicated /engine-settings endpoint (real Postgres
// table); on any other backend (memory / tests) it falls back
// to the key/value Storage the rest of the app still uses. This is the standard
// promotion pattern — see docs/architecture/SCHEMA.md.
import { NO_VALUE_OPT_IN, Storage } from '../storage';
import { apiFetch } from './http';
import type { EngineSettingsSaved } from '../../engine/constants';

const LEGACY_KEY = 'engine_settings_v1';

export async function loadEngineSettings(): Promise<EngineSettingsSaved | null> {
  if (Storage.backend === 'http') {
    try {
      const res = await apiFetch('/engine-settings' + NO_VALUE_OPT_IN);
      // Nothing saved yet → keep the engine defaults. The API says so with 204
      // (#1145); an older one said 404. Neither has a body to parse.
      if (res.status === 204 || !res.ok) return null;
      return (await res.json()) as EngineSettingsSaved;
    } catch (e) {
      console.error('[engineSettings.load] feilet:', e);
      return null;
    }
  }
  const r = await Storage.get(LEGACY_KEY);
  return r?.value ? (JSON.parse(r.value) as EngineSettingsSaved) : null;
}

export async function saveEngineSettings(settings: EngineSettingsSaved): Promise<void> {
  if (Storage.backend === 'http') {
    const res = await apiFetch('/engine-settings', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(settings),
    });
    if (!res.ok) throw new Error('Kunne ikke lagre engine-innstillinger: ' + res.status);
    return;
  }
  await Storage.set(LEGACY_KEY, JSON.stringify(settings));
}
